import { temporarilyNotSupport } from '../../utils'

// 蓝牙-通用
export const stopBluetoothDevicesDiscovery = temporarilyNotSupport('stopBluetoothDevicesDiscovery')
export const startBluetoothDevicesDiscovery = temporarilyNotSupport('startBluetoothDevicesDiscovery')
export const openBluetoothAdapter = temporarilyNotSupport('openBluetoothAdapter')
export const onBluetoothDeviceFound = temporarilyNotSupport('onBluetoothDeviceFound')
export const onBluetoothAdapterStateChange = temporarilyNotSupport('onBluetoothAdapterStateChange')
export const offBluetoothDeviceFound = temporarilyNotSupport('offBluetoothDeviceFound')
export const offBluetoothAdapterStateChange = temporarilyNotSupport('offBluetoothAdapterStateChange')
export const makeBluetoothPair = temporarilyNotSupport('makeBluetoothPair')
export const isBluetoothDevicePaired = temporarilyNotSupport('isBluetoothDevicePaired')
export const getConnectedBluetoothDevices = temporarilyNotSupport('getConnectedBluetoothDevices')
export const getBluetoothDevices = temporarilyNotSupport('getBluetoothDevices')
export const getBluetoothAdapterState = temporarilyNotSupport('getBluetoothAdapterState')
export const closeBluetoothAdapter = temporarilyNotSupport('closeBluetoothAdapter')
